const checkPlanOnDetect = (userPlan: TUserPlan): boolean =>
  userPlan === 'Demo' || userPlan === 'Essential' || userPlan === 'Enterprise';

export default checkPlanOnDetect;
